var AdaptiveImage = require( "../../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js" );

module.exports = new AdaptiveImage({
    uri: __webpack_public_path__ + "9e17bb051a3157fff7aaf2402422d8ce.png",
    width: 198,
    height: 306
});